// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__gvaRx","loading-spinner":"Loading_loading-spinner__OwC2k","iframe_loader":"Loading_iframe_loader__c_Cev"};